export default __webpack_public_path__ + "static/media/mans.5bc2ab06.png";